import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { Blip } from './Blip';

export type StandaloneBlipProps = StandaloneComponentProps<typeof Blip>;

export const StandaloneBlip: StandaloneComponent<StandaloneBlipProps> = (props) => {
  return <Blip {...props} />;
};
